import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { QuizCreatorComponent } from '../../shared-components/quiz-creator/quiz-creator.component';
import { CourseService } from '../services/course.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CourseConstants } from '../constants/course.constants';
import { CourseProficiencyQuiz } from '../models/CourseProficiencyQuiz';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-course-proficiency-quiz-slider',
  templateUrl: './course-proficiency-quiz-slider.component.html',
  styleUrls: ['./course-proficiency-quiz-slider.component.scss']
})
export class CourseProficiencyQuizSliderComponent {
  @Input() courseNumber: string = "";
  @Input() isCourseProficiencyQuizSliderOpen: boolean = false;
  @Input() minimumPassingScore: string | null = null;
  @Output() isCourseProficiencyQuizSliderActive = new EventEmitter<boolean>();
  
  maxOfAttempts: number | null = null;
  quiz: string | null = null;

  topBarTitle: string = CourseConstants.Course_Proficiency_Quiz_Title;
  courseProficiencyQuiz: CourseProficiencyQuiz = {} as CourseProficiencyQuiz;
  courseProficiencyQuizPersistedDetails: CourseProficiencyQuiz = {} as CourseProficiencyQuiz;
  errorMessages: string[] = [];
  loadQuizCreator: boolean = false;
  errorMessageHeaderText = CourseConstants.Course_Proficiency_Quiz_ErrorText;
  showCourseProficiencyQuizLoader: boolean = false;
  spinnerMessage: string = '';
  @ViewChild(QuizCreatorComponent)
  private quizCreatorComponent!: QuizCreatorComponent;
  
  constructor(private courseService: CourseService, private confirmationService: ConfirmationService, private messageService: MessageService){

  }
  ngOnInit(): void {
    this.getCourseProficiencyQuizDetails();
  }

  onMaxOfAttemptsChange = (keyEvent: any) => {
    if (keyEvent.target.value === "") {
      this.maxOfAttempts = null;
    }
    else if (Number(keyEvent.target.value) < 1) {
      this.maxOfAttempts = 1;
    }
  }

  saveProficiencyQuiz() {
    this.quiz = this.quizCreatorComponent.getQuizDetails();
    if (this.validateProficiencyQuiz()) {
      this.prepareCourseProficiencyQuizEntityToSave();
      this.showCourseProficiencyQuizLoader = true;
      this.spinnerMessage = this.courseProficiencyQuiz.courseProficiencyQuizId === null ?
        CourseConstants.Course_Proficieny_Quiz_Save_Progress : CourseConstants.Course_Proficieny_Quiz_Uodate_Progress;
      this.courseService.saveCourseProficiencyQuiz(this.courseProficiencyQuiz)
      .subscribe((quizDetails) => {
        this.courseProficiencyQuizPersistedDetails = quizDetails;
        this.closeSlider();
        this.showToasterMessageOnSave();
        this.showCourseProficiencyQuizLoader = false;
      });
    }
  }

  validateProficiencyQuiz = (): boolean => {
    this.errorMessages = [];
    let isProficiencyQuizValid = true;

    if (this.quiz === null || this.quiz === '"{}"') {
      this.errorMessages.push(this.getErrorMessageText('quiz'));
    }

    return isProficiencyQuizValid = !(this.errorMessages.length > 0);
  }

  prepareCourseProficiencyQuizEntityToSave = () => {
    this.courseProficiencyQuiz.courseProficiencyQuizId = this.courseProficiencyQuizPersistedDetails?.courseProficiencyQuizId;
    this.courseProficiencyQuiz.courseNumber = this.courseNumber;
    this.courseProficiencyQuiz.maximumAttempts = this.maxOfAttempts;
    this.courseProficiencyQuiz.quiz = this.quiz;
  }

  getCourseProficiencyQuizDetails = () => {
    this.spinnerMessage = CourseConstants.Course_Proficieny_Quiz_Details_Loading;
    this.showCourseProficiencyQuizLoader = true;
    this.courseService.getCourseProficiencyQuizDetails(this.courseNumber).subscribe((response) => {
        this.courseProficiencyQuizPersistedDetails = response;
        this.setProficiencyQuizSliderProperties();
        this.showCourseProficiencyQuizLoader = false;
        this.loadQuizCreator = true;
      });
  }

  confirm = () => {
    this.confirmationService.confirm({
      header: CourseConstants.CourseProficiencyQuiz_Slider_Confirmation_Header,
      message: CourseConstants.CourseProficiencyQuiz_Slider_Confirmation_Text,
      icon: "pi pi-exclamation-triangle",
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeSlider();
      }
    });
  }

  closeSlider = () => {
    this.resetQuizCreatorSlider();
    this.isCourseProficiencyQuizSliderOpen = false;
    this.isCourseProficiencyQuizSliderActive.emit(this.isCourseProficiencyQuizSliderOpen);
  }

  resetQuizCreatorSlider = () => {
    this.setProficiencyQuizSliderProperties();
    this.loadQuizCreator = false;
  }

  private getErrorMessageText(labelName: string): string {
    const errorLabelMapper: { [key: string]: string } = {
      minimumPassingScore: CourseConstants.Course_Proficiency_Quiz_Min_Passing_Score_Required,
      quiz: CourseConstants.Course_Proficiency_Quiz_Section_Required,
    };
    return errorLabelMapper[labelName];
  }

  private showToasterMessageOnSave = () => {
    this.messageService.add({
      severity: CourseConstants.Severity_Success,
      summary: CourseConstants.Course_Proficiency_Quiz_Saved_Success
    });
  }

  private setProficiencyQuizSliderProperties = () => {
    this.maxOfAttempts = this.courseProficiencyQuizPersistedDetails?.maximumAttempts ? this.courseProficiencyQuizPersistedDetails.maximumAttempts : null;
    this.quiz = this.courseProficiencyQuizPersistedDetails?.quiz ? this.courseProficiencyQuizPersistedDetails.quiz : null;
  }
}
